import { Navigate } from "react-router-dom";
import { useSubscription } from "@/hooks/useSubscription";

interface SubscriptionGateProps {
  children: React.ReactNode;
}

const SubscriptionGate = ({ children }: SubscriptionGateProps) => {
  const { isActive, loading } = useSubscription();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isActive) {
    return <Navigate to="/planos" replace state={{ blocked: true }} />;
  }

  return <>{children}</>;
};

export default SubscriptionGate;
